module.exports = __webpack_public_path__ + "img/master-card.0a2576f1.svg";